// Normaliza las estaciones de control de plagas que llegan desde la API
export const createEmptyPestControlStations = () => ({
  rodenticide_stations: 0,
  non_toxic_traps: 0,
  pigeon_cages: 0,
  tuv_equipment: 0,
  others: []
})

const normalizeOthers = (others) => {
  if (!Array.isArray(others)) return []
  return others.map((item) => ({
    name: typeof item?.name === 'string' ? item.name : '',
    quantity: toCount(item?.quantity)
  }))
}

const toCount = (value) => {
  const parsed = parseInt(value, 10)
  return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed
}

export const normalizePestControlStations = (stations) => {
  const base = createEmptyPestControlStations()
  if (!stations) return base

  return {
    rodenticide_stations: toCount(stations.rodenticide_stations),
    non_toxic_traps: toCount(stations.non_toxic_traps),
    pigeon_cages: toCount(stations.pigeon_cages),
    tuv_equipment: toCount(stations.tuv_equipment),
    others: normalizeOthers(stations.others)
  }
}
